import * as React from 'react';
import { Route } from 'react-router-dom';
import LazyLoadingWrapper from '@components/LazyLoadingWrapper/LazyLoadingWrapper';
import LayersListWrapper from '@features/map-layers-list/layers-list/LayersListWrapper';
import LayersTimeSelectors from '@features/map-layers-list/time-selector/LayersTimeSelectors';

const Layers = React.lazy(() => import('@pages/ProjectModes/LayersModePage'));
const KeplerLayers = React.lazy(() => import('@pages/ProjectModes/KeplerLayersModePage'));

export const useLayersRoutes = () => {
    return (
        <>
            <Route element={<LazyLoadingWrapper element={<Layers />} />}>
                <Route
                    path="layers"
                    element={
                        <LayersListWrapper>
                            <LayersTimeSelectors />
                        </LayersListWrapper>
                    }
                />
            </Route>
            <Route path="klayers" element={<LazyLoadingWrapper element={<KeplerLayers />} />} />
        </>
    );
};
